import { render, staticRenderFns } from "./precarriage-list.vue?vue&type=template&id=d84cfa4a"
import script from "./precarriage-list.vue?vue&type=script&lang=js"
export * from "./precarriage-list.vue?vue&type=script&lang=js"
import style0 from "./precarriage-list.vue?vue&type=style&index=0&id=d84cfa4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports